import type { ReactNode } from 'react';

import { Box } from '@mui/material';

export const DrawerFooter = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        minHeight: '96px',
        width: '100%',
        backgroundColor: 'gx.mainBackground',
        borderTop: '1px solid',
        borderColor: 'gx.textDisabled',
        p: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 3,
        '& > *': {
          flex: 1
        }
      }}
    >
      {children}
    </Box>
  );
};
